// extracted by mini-css-extract-plugin
module.exports = {"messagesContainer":"styles_messagesContainer__2geyy","paypalBox":"styles_paypalBox__3LrW1","insuranceMessage":"styles_insuranceMessage__3mesN"};